/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type PetCompatibilityAnswerEnum =
  (typeof PetCompatibilityAnswerEnum)[keyof typeof PetCompatibilityAnswerEnum];

export const PetCompatibilityAnswerEnum = {
  yes: 'yes',
  no: 'no',
  unsure: 'unsure',
} as const;
